import React from 'react';
import { cn } from '../../design-system/cn';
import { typography } from '../../design-system/tokens';

const FIELD =
  'w-full px-4 py-3 rounded-xl bg-black/40 border border-white/10 text-white placeholder-gray-500 outline-none transition-all';

const FOCUS = {
  brand: 'focus:border-emerald-500/50 focus:ring-1 focus:ring-emerald-500/50',
  admin: 'focus:border-violet-500/50 focus:ring-1 focus:ring-violet-500/50',
};

export function InputField({
  label,
  error,
  focus = 'brand',
  className,
  inputClassName,
  id,
  children,
  ...props
}) {
  const inputId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

  return (
    <label className={cn('block', className)} htmlFor={inputId}>
      {label && (
        <span className={cn(typography.label, 'text-gray-400')}>{label}</span>
      )}
      {children ?? (
        <input
          id={inputId}
          className={cn('mt-1', FIELD, FOCUS[focus] || FOCUS.brand, inputClassName)}
          {...props}
        />
      )}
      {error && (
        <p className="mt-1.5 text-xs text-red-400 font-medium">{error}</p>
      )}
    </label>
  );
}

export function TextInput({ focus = 'brand', className, ...props }) {
  return (
    <input
      className={cn(
        'mt-1',
        FIELD,
        FOCUS[focus] || FOCUS.brand,
        'text-base sm:text-sm',
        className,
      )}
      {...props}
    />
  );
}

export function SelectInput({ focus = 'brand', className, children, ...props }) {
  return (
    <select
      className={cn(
        'mt-1 appearance-none cursor-pointer',
        FIELD,
        FOCUS[focus] || FOCUS.brand,
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
}
